import type { ReactNode } from "react";
import { MessagesSquare } from "lucide-react";
import { EmptyState, cx } from "../charte";

const PANE = "messaging-pane messaging-live";

/**
 * Mise en page de la messagerie en pleine page, sur toute la hauteur de l'écran : une seule carte,
 * la liste à gauche, la conversation à droite. Le titre et les boutons sont en haut de la liste.
 * Les contenus sont ceux du volet flottant (`MessagingDock`), seule la disposition change.
 * Écran étroit : une colonne à la fois, la liste, puis la conversation avec son retour.
 */
export function MessagingPage({
  status,
  inbox,
  detail,
  canCreate,
}: {
  /** Messagerie indisponible ou en chargement : remplace les deux colonnes. */
  status: ReactNode;
  inbox: ReactNode;
  /** Conversation ouverte, nouveau message ou ouverture en cours ; rien : invitation à choisir. */
  detail: ReactNode;
  canCreate: boolean;
}) {
  const focused = !!detail;
  return (
    <section
      aria-label="Messagerie"
      className="charte-root messaging-root messaging-page"
    >
      <div
        className={cx(
          "messaging-page__card",
          !status && "messaging-page__card--split",
        )}
      >
        {status ? (
          <div className={cx(PANE, "messaging-state")}>{status}</div>
        ) : (
          <>
            <div
              className={cx(
                "messaging-page__list",
                focused && "messaging-page__narrow-hidden",
              )}
            >
              <div className={PANE}>{inbox}</div>
            </div>
            <div
              className={cx(
                "messaging-page__detail",
                !focused && "messaging-page__narrow-hidden",
              )}
            >
              {detail ? (
                <div className={PANE}>{detail}</div>
              ) : (
                <div className="messaging-page__empty">
                  <EmptyState
                    icon={MessagesSquare}
                    title="Choisissez une conversation"
                    description={
                      canCreate
                        ? "Ou commencez-en une avec « Nouveau message »."
                        : "Vos conversations s’affichent ici."
                    }
                  />
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </section>
  );
}
